import { useQuery } from '@tanstack/react-query';
import { findLineItems } from 'utils/OrderWebAPIUtils';
import { filterCanceledShipmentLineItems } from 'components/modules/orders/order-rtb/utils/filterCanceledShipmentLineItems';
const PAGE_SIZE = 100;
async function fetchAllLineItems(invoiceId) {
    var _a, _b, _c, _d, _e, _f, _g;
    const firstResponse = await findLineItems({
        invoice_id: invoiceId,
        line_item_type: 'receivables',
        per_page: PAGE_SIZE,
        page: 1,
    });
    const allItems = (_b = (_a = firstResponse === null || firstResponse === void 0 ? void 0 : firstResponse.entity) === null || _a === void 0 ? void 0 : _a.data) !== null && _b !== void 0 ? _b : [];
    const totalPages = (_e = (_d = (_c = firstResponse === null || firstResponse === void 0 ? void 0 : firstResponse.entity) === null || _c === void 0 ? void 0 : _c.pagination) === null || _d === void 0 ? void 0 : _d.total_pages) !== null && _e !== void 0 ? _e : 1;
    for (let page = 2; page <= totalPages; page++) {
        const response = await findLineItems({
            invoice_id: invoiceId,
            line_item_type: 'receivables',
            per_page: PAGE_SIZE,
            page,
        });
        const items = (_g = (_f = response === null || response === void 0 ? void 0 : response.entity) === null || _f === void 0 ? void 0 : _f.data) !== null && _g !== void 0 ? _g : [];
        allItems.push(...items);
    }
    return filterCanceledShipmentLineItems(allItems);
}
export function useInvoiceLineItems(invoiceId, options = {}) {
    return useQuery({
        queryKey: ['invoice-line-items', invoiceId],
        queryFn: () => {
            if (!invoiceId)
                return [];
            return fetchAllLineItems(invoiceId);
        },
        enabled: options.enabled === undefined
            ? Boolean(invoiceId)
            : Boolean(options.enabled) && Boolean(invoiceId),
        staleTime: 30000,
    });
}
